import { MutationTree } from 'vuex';
import { IAuthState } from '../types';
import { _axios } from '@/plugins/axios';

export const mutations: MutationTree<IAuthState> = {
  LOGIN_SUCCESS(state) {
    state.isLoggedIn = true;
  },
  SET_HEADER(state, token) {
    _axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  },
};
